import { render, staticRenderFns } from "./SatisfactionItem.vue?vue&type=template&id=0cf7d756&"
import script from "./SatisfactionItem.vue?vue&type=script&lang=js&"
export * from "./SatisfactionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports